import React from 'react';
import Link from '../atoms/link';

const Footer = ({
	pageDisclaimer = false
}) => {
	const pageDisclaimerContent = (pageDisclaimer) ? (
		<p>{pageDisclaimer}</p>
	) : null;

	return (
		<div className='co-footer'>
			<div className='co-footer__main'>
				<div className='l-container'>
					<div className='l-grid__row l-grid__middle-xs co-footer__logo-links'>
						<div className='l-grid__col-md co-footer__links--secondary'>
							{/* <Link url='https://www.clearoneadvantage.com/privacypolicy' classNames='co-footer__link'>
								Privacy Policy
							</Link>
							<Link url='https://www.clearoneadvantage.com/termsofuse' classNames='co-footer__link'>
								Terms of Use
							</Link> */}
						</div>
					</div>
					<div className='l-grid__row'>
						<div className='l-grid__col-xs-12 l-spacing__m-t--24 co-footer__disclaimer'>
							{pageDisclaimerContent}
							<p>ClearOne Advantage, LLC is a debt settlement company, not a lender, loan broker, creditor, credit services organization, or debt collector. ClearOne Advantage, LLC does not assume or pay any debts; receive, hold or control funds belonging to consumers; or provide bankruptcy, legal, accounting or tax advice. You should review full program terms and conditions before enrolling. To the extent that any aspect of the debt settlement services relies on or results in the consumer’s failure to make timely payments to the consumer’s creditors or debt collectors, the use of the debt settlement services: (1) Will likely adversely affect the consumer’s creditworthiness; (2) May result in the consumer being subject to collections or being sued by creditors or debt collectors; and (3) May increase the amount of money the consumer owes due to the accrual of fees and interest by creditors or debt collectors. Not available in all states. Some third-party fees may apply. C.P.D. Reg. No. T.S. 12-03822.</p>
							<br />
							<p>ClearOne Advantage is not a credit services organization and we do not make any claims regarding improvement of a consumer’s credit scores. Entering into a debt settlement program could adversely affect your credit score.</p>
						</div>
					</div>
				</div>
			</div>
			<div className='co-footer__copyright'>
				<div className='l-container'>
					<div className='l-grid__row'>
						<div className='l-grid__col-xs'>
							<p>&copy; Copyright {new Date().getFullYear()} ClearOne Advantage. All rights reserved.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
